<template>
  <v-card variant="outlined" density="compact" class="bg-teal mt-3 mb-5">


    <v-card-text>
      <v-form @submit.prevent="addAWinToProgram" density="compact">
        <v-textarea
          clearable
          auto-grow
          density="compact"
          bg-color="white"
          v-model="newWin"
        ></v-textarea>
        <v-btn class="bg-green" block type="submit" :disabled="invalidWin"><span class="text-white">Add new Win to Daily Program</span></v-btn>
      </v-form>
    </v-card-text>


  </v-card>
</template>

<script>
import { addNewItemToProgram } from '@/services/ProgramServices';

export default {
  props: [ 'uId', 'token', 'todayActual', 'order' ],
  data() {
    return {
      newWin: 'STACK Wins every day.',
    };
  },
  computed: {
    invalidWin() {
      // return this.newWin.length > 0 ? false : true;
      return this.newWin.length <= 0;
    },
  },
  methods: {
    async addAWinToProgram() {
      const success = await addNewItemToProgram(this.uId, this.token, this.todayActual, this.newWin.trim(), this.order);
      if (success) {
        window.location.reload();
      }
    }
  }
}
</script>


